module.exports = __webpack_public_path__ + "static/img/usinessPartner_07.64208539.jpg";